
const parseTime = (t: string) => {
  const [time, period] = t.split(' ');
  const [rawHour, minute] = time.split(':').map(Number);
  let hour = rawHour;

  if (period === 'PM' && hour !== 12) hour += 12;
  if (period === 'AM' && hour === 12) hour = 0;

  return hour * 60 + minute;
};
export const getTimeSections = (times: string[] = []) => {
  const sections = {
    morning: [] as string[],
    afternoon: [] as string[],
    evening: [] as string[]
  };
  times?.forEach(t => {
    const minutes = parseTime(t);
    if (minutes < 12 * 60) {
      sections.morning.push(t);
    } else if (minutes < 17 * 60) {
      sections.afternoon.push(t);
    } else {
      sections.evening.push(t);
    }
  });
  return sections;
};
